<template>
  <div class="wrapper">
    <LoginDialog/>
    <MenuBar/>
    <!-- :key für update bei seiten mit gleichen pfad aber anderen parametern im pfad -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import MenuBar from '@/components/MenuBar.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import security from '@/modules/security.js'

export default {
  name: 'App',
  components: {
    MenuBar,
    LoginDialog
  },
  created: function() {
    this.checkLoginState();
    setInterval(this.checkLoginState.bind(this),30000);
  },
  methods: {
    checkLoginState: function() {
      var self = this;
      security.whoami().then(function(data) {
        if (!(data && data.userid && data.userid > 0)) {
          self.$bvModal.show('loginDialog');
        }
      })
    }
  }
}
</script>

<style>
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

.selector-for-some-widget {
  box-sizing: content-box;
}

</style>
